import { render, staticRenderFns } from "./cate-module.vue?vue&type=template&id=07bba950&scoped=true"
import script from "./cate-module.vue?vue&type=script&lang=js"
export * from "./cate-module.vue?vue&type=script&lang=js"
import style0 from "./cate-module.vue?vue&type=style&index=0&id=07bba950&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bba950",
  null
  
)

export default component.exports